import { Component, ViewChild } from '@angular/core';
import { DisplayService } from 'src/app/services/display.service';
import { TableService } from 'src/app/services/table.service';
import { IntegrationDetails } from 'src/app/models/integration-details';
import { IntegrationAction } from 'src/app/models/integration-action';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { TenantService } from 'src/app/services/tenant.service';
import { DataLakeService } from 'src/app/services/data-lake.service';
import { AdminService } from 'src/app/services/admin.service';
import { UserV2 } from 'src/app/models/admin/user-v2';
import { Role } from 'src/app/models/admin/role';
import { AuthService } from 'src/app/services/auth-service.service';
import { MyAccess } from 'src/app/models/my-access';
import { StringLocalizerService } from 'src/app/services/string-localizer.service';
import { BusinessLogicService } from 'src/app/services/business-logic.service';
import { ToastService } from 'src/app/services/toast.service';
import { ModalService } from 'src/app/modal/modal.service';
type SectionKey = 'action' | 'tables' | 'rundata' | 'dataLake' | 'runlog' | 'errors' | 'admin';

@Component({
    selector: 'app-side-nav',
    templateUrl: './side-nav.component.html',
    styleUrls: ['./side-nav.component.css'],
    standalone: false
})
export class SideNavComponent {
  private static readonly REQUIRED_ADMIN_FEATURE = 'DISDashboardAdmin';
  private static readonly REQUIRE_AUTHZ_FEATURES = 'Dashboard:RequireAuthZ';
  public showAdminNav = false;
  public user: UserV2;
  public userRoles: Role[] = [];
  private $connections = new BehaviorSubject<IntegrationDetails[]>([]);
  public connections = this.$connections.asObservable();
  public selectedIntegration: string;
  navMode: boolean = true;
  public selectedIndex: number;
  @ViewChild('tabs', { static: false }) tabs;
  childDisplay: string = "";
  childDisplayTable: string = "";
  myAccess: MyAccess = null;

  private $integrations = new BehaviorSubject<IntegrationDetails[]>([]);
  public $integrationActions = new BehaviorSubject<IntegrationAction[]>(null);

  public integrationsList = [];
  public connectionsList = [];
  public tablesList = [];

  public integrationSelected: string = null;
  public processRunning: boolean = false;
  public processFinished: boolean = false;

  public collator = new Intl.Collator(undefined, { numeric: true, sensitivity: "base" });
  public preserveOrder = () => 0;
  public actionDisabled: boolean = false;

  public isDemo: boolean = false;
  public isDemoRunning: boolean = false;
  public isDemoCompleted: boolean = false;
  public isDrawerOpen: boolean = false;

  actionDisplay: boolean = false;
  tablesDisplay: boolean = false;
  dataValidationDisplay: boolean = false;
  ErrorsDisplay: boolean = false;
  outputsDisplay: boolean = false;
  processLogDisplay: boolean = false;
  adminDisplay: boolean = false;

  buttonStatus: string = "";
  spanStatus: string = "";
  spanButtonStatus: string = "";
  actionsHighlight: boolean = false;
  tablesHighlight: boolean = false;
  dataValidationsHighlight: boolean = false;
  outputsHighlight: boolean = false;
  runLogHighlight: boolean = false;
  errorHighlight: boolean = false;
  public strings: {} = {};
  public subMenu: string = "";
  private switching = false;

  private $actionSolutions = new BehaviorSubject<IntegrationDetails[]>([]);
  public actionSolutions = this.$actionSolutions.asObservable();
  private $filteredActionSolutions = new BehaviorSubject<IntegrationDetails[]>([]);
  public filteredActionSolutions = this.$filteredActionSolutions.asObservable();

  private $tables = new BehaviorSubject<any[]>([]);
  public tables = this.$tables.asObservable();
  private $filteredTableSolutions = new BehaviorSubject<any[]>([]);
  public filteredTableSolutions = this.$filteredTableSolutions.asObservable();

  private $dataValidationSolutions = new BehaviorSubject<string[]>([]);
  public dataValidationSolutions = this.$dataValidationSolutions.asObservable();
  private $filteredDataValidationSolutions = new BehaviorSubject<string[]>([]);
  public filteredDataValidationSolutions = this.$filteredDataValidationSolutions.asObservable();

  private $dataValidationSolutionAliases = new BehaviorSubject<Map<string, string>>(new Map<string, string>());
  public dataValidationSolutionAliases = this.$dataValidationSolutionAliases.asObservable();
  private $filteredDataValidationSolutionAliases = new BehaviorSubject<Map<string, string>>(new Map<string, string>());
  public filteredDataValidationSolutionAliases = this.$filteredDataValidationSolutionAliases.asObservable();

  private $dataLakeSolutions = new BehaviorSubject<Map<string, string>>(new Map<string, string>());
  public dataLakeSolutions = this.$dataLakeSolutions.asObservable();
  private $filteredDataLakeSolutions = new BehaviorSubject<Map<string, string>>(new Map<string, string>());
  public filteredDataLakeSolutions = this.$filteredDataLakeSolutions.asObservable();

  private $runLogSolutions = new BehaviorSubject<Map<string, string>>(new Map<string, string>());
  public runLogSolutions = this.$runLogSolutions.asObservable();
  private $filteredRunLogSolutions = new BehaviorSubject<Map<string, string>>(new Map<string, string>());
  public filteredRunLogSolutions = this.$filteredRunLogSolutions.asObservable();

  private $errorLogSolutions = new BehaviorSubject<Map<string, string>>(new Map<string, string>());
  public errorLogSolutions = this.$errorLogSolutions.asObservable();
  private $filteredErrorLogSolutions = new BehaviorSubject<Map<string, string>>(new Map<string, string>());
  public filteredErrorLogSolutions = this.$filteredErrorLogSolutions.asObservable();
  initialButtonClick = true;
  private confirmResolveFn: ((ok: boolean) => void) | null = null;
  private integrationOrderByName = new Map<string, number>();

  constructor(
    private displayService: DisplayService,
    private tableService: TableService,
    private businessLogicService: BusinessLogicService,
    private dataLakeService: DataLakeService,
    private adminService: AdminService,
    private stringLocalizerService: StringLocalizerService,
    private toastService: ToastService,
    private modalService: ModalService) {
    this.adminService.$myAccess.subscribe(myAccess => {
      if (myAccess != null) {
        this.myAccess = myAccess;
      }
      const features = myAccess?.userFeatures ?? [];

      const flag = myAccess?.flags?.find(f => f.name === SideNavComponent.REQUIRE_AUTHZ_FEATURES);
      const requireAuthZ = flag ? flag.enabled : false;
      this.showAdminNav = myAccess && (!requireAuthZ || features.includes(SideNavComponent.REQUIRED_ADMIN_FEATURE));
    });
    this.businessLogicService.$integrations.subscribe(integrations => {
      if (integrations != null) {
        const sorted = this.sortIntegrations(integrations);
        this.$integrations.next(sorted);
        // Build the order map for later use
        this.integrationOrderByName = new Map(
          sorted.map(i => [i.name, (i.order ?? Number.MAX_SAFE_INTEGER)])
        );
       // Actions uses IntegrationDetails[] directly
       this.$actionSolutions.next(sorted);
      }
    });
    this.stringLocalizerService.strings.subscribe(s => {
      if (s) {
        this.strings = this.stringLocalizerService.getSection("sideNav");
      }
    });
    // this.$filteredDataValidationSolutions.subscribe(solutions => {
    //   var aliases: string[] = [];
    //   solutions.forEach(solutionName => {
    //     const integration = this.$integrations.value.find(i => i.name === solutionName);
    //     if (integration) {
    //       aliases.push(integration.alias);
    //     }
    //   });
    //   this.$filteredDataValidationSolutionAliases.next(aliases);
    // });
  }

  async loadMyAccess() {
    await this.adminService.loadMyAccess();
  }

  async getUserAndRoles(): Promise<void> {
    if (!this.user || !Array.isArray(this.user.roles)) return;

    if (this.userRoles.length === 0) {
      for await (const userRole of this.user.roles) {
        if (!userRole?.id) continue;
        const r = await this.adminService.getRole(userRole.id);
        if (r) this.userRoles.push(r);
      }
    }
  }

  private sortIntegrations(integrations: IntegrationDetails[]): IntegrationDetails[] {
    const sorted = [...integrations].sort((a, b) => {
      if (a.order !== b.order) return a.order - b.order;
      return this.collator.compare(a.name, b.name);
    });
    return sorted;
  }

  filterActionSolutionsList(searchString: string): void {
    const solutions = this.$actionSolutions?.getValue?.() ?? this.$integrations?.value ?? [];
    const term = searchString?.trim().toLowerCase();


    const filtered = term
      ? solutions.filter(i => (i.alias ?? i.name).toLowerCase().includes(term))
      : solutions;

    this.$filteredActionSolutions.next(filtered);
  }

  filterTablesSolutionsList(searchString) {
    if (searchString != "") {
      let newSolutions = this.$tables.pipe(
        map(solutions => solutions.filter(solution => solution.name.toLowerCase().includes(searchString.toLowerCase())))
      )
      newSolutions.forEach(x => this.$filteredTableSolutions.next(x))
    } else {
      this.$tables.forEach(x => this.$filteredTableSolutions.next(x))
    }
  }

  filterDataValidationSolutionsList(searchString) {
    const roleFilteredBaseline = this.$dataValidationSolutionAliases.value;
    if (searchString != "") {
      const term = searchString.toLowerCase();
      const filtered = new Map<string, string>(
        [...roleFilteredBaseline.entries()].filter(([name, alias]) =>
          name.toLowerCase().includes(term) || alias.toLowerCase().includes(term)
        )
      );
      this.$filteredDataValidationSolutionAliases.next(filtered);
    } else {
      this.$filteredDataValidationSolutionAliases.next(new Map<string, string>(roleFilteredBaseline));
    }
  }

  filterOutputSolutionsList(searchString) {
    if (searchString != "") {
      const term = searchString.toLowerCase();
      const filtered = new Map<string, string>(
        [...this.$dataLakeSolutions.value.entries()].filter(([name, alias]) =>
          alias.toLowerCase().includes(term)
        )
      );
      this.$filteredDataLakeSolutions.next(filtered);
    } else {
      this.$filteredDataLakeSolutions.next(new Map<string, string>(this.$dataLakeSolutions.value));
    }
  }

  filterRunLogSolutionsList(searchString) {
    if (searchString != "") {
      const term = searchString.toLowerCase();
      const filtered = new Map<string, string>(
        [...this.$runLogSolutions.value.entries()].filter(([name, alias]) =>
          alias.toLowerCase().includes(term)
        )
      );
      this.$filteredRunLogSolutions.next(filtered);
    } else {
      this.$filteredRunLogSolutions.next(new Map<string, string>(this.$runLogSolutions.value));
    }
  }

  filterErrorSolutionsList(searchString) {
    if (searchString != "") {
      const term = searchString.toLowerCase();
      const filtered = new Map<string, string>(
        [...this.$errorLogSolutions.value.entries()].filter(([name, alias]) =>
          alias.toLowerCase().includes(term)
        )
      );
      this.$filteredErrorLogSolutions.next(filtered);
    } else {
      this.$filteredErrorLogSolutions.next(new Map<string, string>(this.$errorLogSolutions.value));
    }
  }

  public expandSubMenu(subMenuName: string) {
    this.subMenu = (this.subMenu === subMenuName) ? "" : subMenuName;
    this.buttonStatus = this.subMenu;

    // Update primary breadcrumb 
    if (this.subMenu) {
      this.setBreadCrumbs(subMenuName);
      // Clear sub crumbs 
      this.displayService.setSelectedSpanText("");
      this.displayService.setDataStudioTitle("");
    }
  }

  //Action methods
  async loadActionSolutions() {
    this.actionsHighlight = false;

    const reducedActions = await this.reduceActionsByRoles(this.$actionSolutions.value);
    this.$actionSolutions.next(reducedActions);
    this.$filteredActionSolutions.next(reducedActions);
  }

  async selectActionSolution(solutionName: string) {
    this.displayService.toggleGrayOut(true);
    this.initialButtonClick = false;
    this.displayService.selectActionSolution(solutionName);
    this.displayService.setDataStudioDisplay("action");
    this.spanStatus = solutionName;
    this.actionsHighlight = true;
    this.displayService.toggleGrayOut(false);
  }

  private async reduceActionsByRoles(actions: IntegrationDetails[]) {
    await this.loadMyAccess();
    var myAccess = this.adminService.myAccess;
    var reducedList: IntegrationDetails[] = [];
    actions.forEach(a => {
      var integrationPermissions = myAccess.integrations.find(i => i.name === a.name);
      if (integrationPermissions != null && integrationPermissions.process) {
        reducedList.push(a);
      }
    });
    return reducedList;
  }

  //Tables methods
  async loadTableNames() {
    this.tablesHighlight = false;
    await this.tableService.loadTables();
    this.$tables.next(this.tableService.$tables.value);
    this.$filteredTableSolutions.next(this.tableService.$tables.value);
  }

  private hasPendingTableEdits(): boolean {
    return !!this.tableService.myTableChanges?.editedRows?.rows?.currentChanges?.size;
  }
  private async confirmBeforeLeaving(nextTableId?: string): Promise<boolean> {
    if (!this.tableService.isTableValid) {
      this.toastService.showErrorToast('Please fix invalid entries before leaving the table.', '');
      return false;
    }
    if (this.hasPendingTableEdits() && this.tableService.selectedTable?.id) {
      const leave = await this.openConfirmModal();
      if (!leave) return false;
      this.tableService.resetChangeTracking(this.tableService.selectedTable.id);
    }
    if (nextTableId) {
      this.tableService.resetChangeTracking(nextTableId);
    }
    return true;
  }

  confirmSwitchResolve(choice: boolean) {
    this.modalService.close('confirm-switch');
    this.confirmResolveFn?.(choice);
    this.confirmResolveFn = null;
  }

  private openConfirmModal(): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      this.confirmResolveFn = resolve;
      this.modalService.open('confirm-switch');
    });
  }

  private async prepareToSwitch(nextId: string): Promise<boolean> {
    const currentId = this.tableService.selectedTable?.id;
    const sameTable = currentId === nextId;
    const isTablesDisplay = this.displayService.$dataStudioDisplay.value === 'tables';
    if (sameTable && isTablesDisplay) {
      return false;
    }

    const hasPending = !!this.tableService.myTableChanges?.editedRows?.rows?.currentChanges?.size;
    if (hasPending && currentId) {
      const leave = await this.openConfirmModal();
      if (!leave) return false;
      this.tableService.resetChangeTracking(currentId);
    }

    // Only reset the next table's tracker if we're actually changing tables
    if (nextId && currentId !== nextId) {
      this.tableService.resetChangeTracking(nextId);
    }
    return true;
  }

  async selectTable(tableId: string, tableName: string) {
    if (!this.tableService.isTableValid) {
      this.toastService.showErrorToast('Please fix invalid entries before leaving the table', '');
      return;
    }
    if (this.switching) return;
    this.switching = true;

    let didToggle = false;
    try {
      const proceed = await this.prepareToSwitch(tableId);
      if (!proceed) return;

      this.displayService.toggleGrayOut(true);
      didToggle = true;
      this.initialButtonClick = false;

      this.tableService.selectTable(tableId);
      await this.tableService.loadSelectedTable();

      this.displayService.selectTable(tableId);
      this.displayService.setDataStudioDisplay("tables");
      this.spanStatus = tableName;
      this.tablesHighlight = true;
    } finally {
      if (didToggle) {
        this.displayService.toggleGrayOut(false);
      }
      this.switching = false;
    }
  }

  //Data Validation methods
  async loadDataValidationSolutions() {
    // Get list of solution folders from the datalake
    // then cross reference with integrations to get aliases and filter by roles
    await this.dataLakeService.loadDataLakeRunDataSolutionNames();
    var solutions = this.dataLakeService.$dataLakeRunData.getValue().solutionListings.map(s => s.name);
    const aliasMap = new Map<string, string>();
    solutions.forEach(s => {
      const integration = this.$integrations.value.find(i => i.name === s);
      aliasMap.set(s, integration ? integration.alias : s);
    });
    this.dataValidationsHighlight = false;
    let reducedSolutions: Map<string, string> = await this.reduceDataValidationByRoles(aliasMap);
    reducedSolutions = this.sortSolutionNamesByTenantOrder(reducedSolutions);
    // Store the role-filtered result as the search baseline
    this.$dataValidationSolutionAliases.next(reducedSolutions);
    this.$filteredDataValidationSolutionAliases.next(new Map<string, string>(reducedSolutions));
  }

  private async reduceDataValidationByRoles(solutions: Map<string, string>): Promise<Map<string, string>> {
    await this.loadMyAccess();
    var myAccess = this.adminService.myAccess;
    var reducedList: Map<string, string> = new Map<string, string>();
    solutions.forEach((alias, name) => {
      var integrationPermissions = myAccess.integrations.find(i => i.name === name);
      if (integrationPermissions != null && integrationPermissions.dataValidation) {
        reducedList.set(name, alias);
      }
    });
    return reducedList;
  }


  async selectDataValidationSolution(solutionName: string) {
    this.displayService.toggleGrayOut(true);
    this.initialButtonClick = false;
    this.displayService.selectDataValidationSolution(solutionName);
    await this.dataLakeService.loadDataLakeRunDataDates(solutionName);
    this.displayService.setDataStudioDisplay("rundata");
    this.spanStatus = solutionName;
    this.displayService.dataValidationDrawerOpen(true);
    this.dataValidationsHighlight = true;

    this.displayService.toggleGrayOut(false);
  }

  //Data Lake methods
  async loadDataLakeSolutions() {
    this.outputsHighlight = false;
    await this.dataLakeService.loadOutputSolutionNames();
    var solutions = this.dataLakeService.$dataLakeFiles.value.solutionListings.map(s => s.name);
    const aliasMap = new Map<string, string>();
    solutions.forEach(s => {
      const integration = this.$integrations.value.find(i => i.name === s);
      aliasMap.set(s, integration ? integration.alias : s);
    });
    let reducedSolutions = await this.reduceDataLakeSolutionsByRoles(aliasMap);
    reducedSolutions = this.sortSolutionNamesByTenantOrder(reducedSolutions);
    this.$dataLakeSolutions.next(reducedSolutions);
    this.$filteredDataLakeSolutions.next(new Map<string, string>(reducedSolutions));
  }

  private async reduceDataLakeSolutionsByRoles(solutions: Map<string, string>): Promise<Map<string, string>> {
    await this.loadMyAccess();
    var myAccess = this.adminService.myAccess;
    var reducedList = new Map<string, string>();
    solutions.forEach((alias, name) => {
      var integrationPermissions = myAccess.integrations.find(i => i.name === name);
      if (integrationPermissions != null && integrationPermissions.dataFiles) {
        reducedList.set(name, alias);
      }
    });
    return reducedList;
  }

  async selectDataLakeSolution(solutionName: string) {
    this.displayService.toggleGrayOut(true);
    this.initialButtonClick = false;
    this.displayService.selectDataLakeSolution(solutionName);
    await this.dataLakeService.loadOutputDates(solutionName);
    this.displayService.setDataStudioDisplay("dataLake");
    this.spanStatus = solutionName;
    this.outputsHighlight = true;

    this.displayService.toggleGrayOut(false);
  }

  //Run Log methods
  async loadRunLogSolutions() {
    this.runLogHighlight = false;
    await this.dataLakeService.loadDataLakeRunDataSolutionNames();
    const solutions = this.dataLakeService.$dataLakeRunData.value.solutionListings.map(s => s.name);
    const aliasMap = new Map<string, string>();
    solutions.forEach(s => {
      const integration = this.$integrations.value.find(i => i.name === s);
      aliasMap.set(s, integration ? integration.alias : s);
    });
    let reducedSolutions = await this.reduceRunLogByRoles(aliasMap);
    reducedSolutions = this.sortSolutionNamesByTenantOrder(reducedSolutions);
    this.$runLogSolutions.next(reducedSolutions);
    this.$filteredRunLogSolutions.next(new Map<string, string>(reducedSolutions));
  }

  private async reduceRunLogByRoles(solutions: Map<string, string>): Promise<Map<string, string>> {
    await this.loadMyAccess();
    var myAccess = this.adminService.myAccess;
    var reducedList = new Map<string, string>();
    solutions.forEach((alias, name) => {
      var integrationPermissions = myAccess.integrations.find(i => i.name === name);
      if (integrationPermissions != null && integrationPermissions.runLog) {
        reducedList.set(name, alias);
      }
    });
    return reducedList;
  }

  async selectRunLogSolution(solutionName: string) {
    this.displayService.toggleGrayOut(true);
    this.initialButtonClick = false;
    this.displayService.selectRunLogSolution(solutionName);
    await this.dataLakeService.loadDataLakeRunDataDates(solutionName);
    this.displayService.setDataStudioDisplay("runlog");
    this.spanStatus = solutionName;
    this.runLogHighlight = true;

    this.displayService.toggleGrayOut(false);
  }

  //Error Log methods
  async loadErrorLogSolutions() {
    this.errorHighlight = false;
    await this.dataLakeService.loadDataLakeRunDataSolutionNames();
    var solutions = this.dataLakeService.$dataLakeRunData.value.solutionListings.map(s => s.name);
    const aliasMap = new Map<string, string>();
    solutions.forEach(s => {
      const integration = this.$integrations.value.find(i => i.name === s);
      aliasMap.set(s, integration ? integration.alias : s);
    });
    let reducedSolutions = await this.reduceErrorLogByRoles(aliasMap);
    reducedSolutions = this.sortSolutionNamesByTenantOrder(reducedSolutions);
    this.$errorLogSolutions.next(reducedSolutions);
    this.$filteredErrorLogSolutions.next(new Map<string, string>(reducedSolutions));
    this.displayService.errorLogDrawer(true);
  }
  private async reduceErrorLogByRoles(solutions: Map<string, string>): Promise<Map<string, string>> {
    await this.loadMyAccess();
    var myAccess = this.adminService.myAccess;
    var reducedList = new Map<string, string>();
    solutions.forEach((alias, name) => {
      var integrationPermissions = myAccess.integrations.find(i => i.name === name);
      if (integrationPermissions != null && integrationPermissions.errorLog) {
        reducedList.set(name, alias);
      }
    });
    return reducedList;
  }


  async selectErrorLogSolution(solutionName: string) {
    this.displayService.toggleGrayOut(true);
    this.initialButtonClick = false;
    this.displayService.selectErrorLogSolution(solutionName);
    await this.dataLakeService.loadDataLakeRunDataDates(solutionName);
    this.displayService.setDataStudioDisplay("errors");
    this.spanStatus = solutionName;
    this.errorHighlight = true;

    this.displayService.toggleGrayOut(false);
  }

  //Debug
  async selectedDebug(debug: string) {
    await this.displayService.setDataStudioDisplay(debug);
    this.displayService.setPrimaryButtonText('Debug');
    this.displayService.setSelectedSpanText("");
    this.displayService.setDataStudioTitle("");
  }
  //Debug
  async selectedAdmin(admin: string) {
    if (!this.tableService.isTableValid) {
      this.toastService.showErrorToast('Please fix invalid entries before leaving the table.', '');
      return;
    }
    this.displayService.setDataStudioDisplay(admin);
    this.displayService.setPrimaryButtonText('Admin');
    this.displayService.setSelectedSpanText("");
    this.displayService.setDataStudioTitle("");
  }

  setBreadCrumbs(name) {
    if (name === 'action') {
      this.displayService.setPrimaryButtonText(this.strings["actions"]);
    } else {
      if (name === 'tables') {
        this.displayService.setPrimaryButtonText(this.strings["tables"]);
      } else {
        if (name === 'rundata') {
          this.displayService.setPrimaryButtonText(this.strings["dataValidation"]);
        } else {
          if (name === 'dataLake') {
            this.displayService.setPrimaryButtonText(this.strings["output"]);
          } else {
            if (name === 'runlog') {
              this.displayService.setPrimaryButtonText(this.strings["processLogs"]);
            } else {
              if (name === 'errors') {
                this.displayService.setPrimaryButtonText(this.strings["warningsAndErrors"]);
              } else {
                if (name === 'admin') {
                  this.displayService.setPrimaryButtonText(this.strings["admin"]);
                }
              }
            }
          }
        }
      }
    }
  }

  private async navigateToSection(
    section: SectionKey,
    resetHighlight: () => void,
    loader: () => Promise<void>,
    options?: { showLogo?: boolean }
  ): Promise<void> {
    const ok = await this.confirmBeforeLeaving();
    if (!ok) return;

    this.expandSubMenu(section);
    this.spanStatus = '';
    resetHighlight();

    // Clear secondary/tertiary crumbs on top-level navigation
    this.displayService.setSelectedSpanText('');
    this.displayService.setDataStudioTitle('');

    if (options?.showLogo ?? true) {
      this.displayService.setDataStudioDisplay('logo');
    }

    this.displayService.toggleGrayOut(true);
    try {
      await loader();
    } finally {
      this.displayService.toggleGrayOut(false);
    }
  }

  async onClickActions() {
    await this.navigateToSection(
      'action',
      () => { this.actionsHighlight = false; },
      async () => {
        await this.loadActionSolutions();
        await this.getUserAndRoles?.();
      }
    );
  }

  async onClickTables() {
    await this.navigateToSection(
      'tables',
      () => { this.tablesHighlight = false; },
      () => this.loadTableNames()
    );
  }

  async onClickDataValidation() {
    await this.navigateToSection(
      'rundata',
      () => { this.dataValidationsHighlight = false; },
      () => this.loadDataValidationSolutions()
    );
  }

  async onClickOutput() {
    await this.navigateToSection(
      'dataLake',
      () => { this.outputsHighlight = false; },
      () => this.loadDataLakeSolutions()
    );
  }

  async onClickRunLog() {
    await this.navigateToSection(
      'runlog',
      () => { this.runLogHighlight = false; },
      () => this.loadRunLogSolutions()
    );
  }

  async onClickErrors() {
    await this.navigateToSection(
      'errors',
      () => { this.errorHighlight = false; },
      () => this.loadErrorLogSolutions()
    );
  }

  async onClickAdmin() {
    await this.navigateToSection(
      'admin',
      () => { /* no highlight to clear for admin */ },
      () => this.selectedAdmin('admin'),
      { showLogo: false }
    );
  }
  private sortSolutionNamesByTenantOrder(nameAliasMap: Map<string, string>): Map<string, string> {
    // Build order from the current integrations list to keep nav sorting aligned with tenant config.
    const orderByName = new Map(
      (this.$integrations.value ?? []).map(i => [i.name, (i.order ?? Number.MAX_SAFE_INTEGER)])
    );

    const sortedEntries = [...nameAliasMap.entries()].sort(([aName], [bName]) => {
      const aOrder = orderByName.get(aName) ?? Number.MAX_SAFE_INTEGER;
      const bOrder = orderByName.get(bName) ?? Number.MAX_SAFE_INTEGER;
      if (aOrder !== bOrder) return aOrder - bOrder;
      return this.collator.compare(aName, bName);
    });

    return new Map<string, string>(sortedEntries);
  }

  private sortSolutionNamesArrayByTenantOrder(names: string[]): string[] {
    const orderByName = new Map(
      (this.$integrations.value ?? []).map(i => [i.name, (i.order ?? Number.MAX_SAFE_INTEGER)])
    );

    return [...(names ?? [])].sort((a, b) => {
      const aOrder = orderByName.get(a) ?? Number.MAX_SAFE_INTEGER;
      const bOrder = orderByName.get(b) ?? Number.MAX_SAFE_INTEGER;
      if (aOrder !== bOrder) return aOrder - bOrder;
      return this.collator.compare(a, b);
    });
  }
}
